import {
    OPERATOR_TYPES_1,
    OPERATOR_TYPES_3,
  } from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';

export const EVALUATION_TYPE = {
    CONVERSATION_SPEIFIC: 'conversation_specific',
    AGENT_SPECIFIC: 'agent_specific',
}
export const EVALUATION_TYPE_INT = {
    CONVERSATION_SPEIFIC: 0,
    AGENT_SPECIFIC: 1,
}
export const EVALUATION_TYPES_INT = [
    {
        id: EVALUATION_TYPE_INT.AGENT_SPECIFIC,
        title: "CAMPAIGN.EVALUATIONS.ADD.SPECIFICATION_TYPES.AI_AGENT"
    },
    {
        id: EVALUATION_TYPE_INT.CONVERSATION_SPEIFIC,
        title: "CAMPAIGN.EVALUATIONS.ADD.SPECIFICATION_TYPES.CONVERSATION"
    }

]
export const EVALUATION_REPORT_TYPES = [
    {
        id: 0,
        title: "CAMPAIGN.EVALUATIONS.FILTERS.RESULT_TYPE.CALL"
    },
    {
        id: 1,
        title: "CAMPAIGN.EVALUATIONS.FILTERS.RESULT_TYPE.CHAT"
    }

]
export const EVALUATION_TYPES = [
    {
        id: EVALUATION_TYPE.AGENT_SPECIFIC,
        title: "CAMPAIGN.EVALUATIONS.ADD.SPECIFICATION_TYPES.AI_AGENT"
    },
    {
        id: EVALUATION_TYPE.CONVERSATION_SPEIFIC,
        title: "CAMPAIGN.EVALUATIONS.ADD.SPECIFICATION_TYPES.CONVERSATION"
    }

]


export const evalFilterTypes = [
    {
        attributeKey: 'name',
        attributeI18nKey: 'Name',
        inputType: 'plain_text',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_3,
        attribute_type: 'standard',
    },
    {
        attributeKey: 'agent_name',
        attributeI18nKey: 'Agent Name',
        inputType: 'plain_text',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_3,
        attribute_type: 'standard',
    },
    {
        attributeKey: 'kind',
        attributeI18nKey: 'Type',
        inputType: 'search_select',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_1,
        attribute_type: 'standard',
    },
]

export const FilterAttributList = [
    {
        key: "name",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.NAME'
    },
    {
        key: "agent_name",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.AGENT_NAME'
    },
    {
        key: "kind",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.KIND'
    },
    // kind
]



export const evalReportFilterTypes = [
    {
        attributeKey: 'result',
        attributeI18nKey: 'Result',
        inputType: 'plain_text',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_3,
        attribute_type: 'standard',
    },
    {
        attributeKey: 'agent_name',
        attributeI18nKey: 'Agent Name',
        inputType: 'plain_text',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_3,
        attribute_type: 'standard',
    },
    {
        attributeKey: 'kind',
        attributeI18nKey: 'Type',
        inputType: 'search_select',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_1,
        attribute_type: 'standard',
    },
    {
        attributeKey: 'contact_name',
        attributeI18nKey: 'Contact Name',
        inputType: 'plain_text',
        dataType: 'text',
        filterOperators: OPERATOR_TYPES_3,
        attribute_type: 'standard',
    },
]


export const FilterReportAttributList = [
    {
        key: "result",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.RESULT'
    },
    {
        key: "agent_name",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.AGENT_NAME'
    },
    {
        key: "kind",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.KIND'
    },
    {
        key: "contact_name",
        name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.CONTACT_NAME'
    },

]
